<div class="cv-studio-pane-header">
  <h2>{{ 'cv_house.title' | translate }}</h2>
</div>
<p class="cv-studio-pane-description">{{ 'cv_house.description' | translate }}</p>

<!-- Upload form -->
<form [formGroup]="uploadForm" class="cv-house-upload-form">
  <div class="cv-house-upload-row">
    <label class="cv-studio-upload-field">
      {{ 'cv_house.kind_label' | translate }}
      <nb-select formControlName="kind" size="small">
        <nb-option *ngFor="let k of kinds" [value]="k">{{ 'cv_house.kind.' + k | translate }}</nb-option>
      </nb-select>
    </label>

    <label class="cv-studio-upload-field">
      {{ 'cv_house.language_label' | translate }}
      <nb-select formControlName="language" size="small">
        <nb-option *ngFor="let l of languages" [value]="l">{{ 'cv_house.language.' + l | translate }}</nb-option>
      </nb-select>
    </label>
  </div>

  <label class="cv-studio-upload-field">
    {{ 'cv_house.file_label' | translate }}
    <div class="cv-studio-file-drop"
         [class.dragging]="dragging"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">
      <input type="file" accept="application/pdf" (change)="onFilePicked($event)" />
      <span *ngIf="!file" class="hint">{{ 'cv_house.file_hint' | translate }}</span>
      <span *ngIf="file" class="filename">{{ file.name }}</span>
    </div>
    <small class="text-danger" *ngIf="fileError">{{ fileError }}</small>
  </label>

  <div class="cv-house-upload-actions">
    <button nbButton status="primary" size="small" type="button"
            (click)="submitUpload()" [disabled]="!canUpload">
      <nb-icon *ngIf="uploading" icon="loader-outline"></nb-icon>
      {{ 'cv_house.upload_button' | translate }}
    </button>
  </div>
</form>

<div class="cv-house-divider"></div>

<!-- List -->
<div class="cv-house-list" [nbSpinner]="loading" nbSpinnerStatus="primary">
  @if (error) {
    <p class="cv-studio-empty cv-studio-error">{{ error }}</p>
  } @else if (!loading && exemplars.length === 0) {
    <p class="cv-house-empty">{{ 'cv_house.empty' | translate }}</p>
  }

  @for (e of exemplars; track e.id) {
    <article class="cv-house-row">
      <header class="cv-house-row-head">
        <div class="cv-house-row-meta">
          <span class="cv-house-row-kind">{{ 'cv_house.kind.' + e.kind | translate }}</span>
          <span class="cv-house-row-lang">{{ 'cv_house.language.' + e.language | translate }}</span>
          <span class="cv-house-status cv-house-status-{{ e.status }}">
            {{ 'cv_house.status.' + e.status | translate }}
          </span>
          <span class="cv-house-row-source">{{ 'cv_house.source.' + e.source_type | translate }}</span>
        </div>
        <button nbButton ghost status="danger" size="tiny" type="button"
                (click)="confirmDelete(e)">
          <nb-icon icon="trash-2-outline"></nb-icon>
          {{ 'cv_house.delete_button' | translate }}
        </button>
      </header>

      @if (e.status === 'processing') {
        <p class="cv-house-processing">{{ 'cv_house.processing_hint' | translate }}</p>
      }

      @if (e.status === 'failed') {
        <p class="cv-house-failure">
          {{ 'cv_house.failed_hint' | translate }}
          @if (e.failure_reason) { <span class="cv-house-failure-reason">{{ e.failure_reason }}</span> }
        </p>
      }

      @if (isDraft(e)) {
        @if (hasLeakWarnings(e)) {
          <div class="cv-house-leak-banner">
            <nb-icon icon="alert-triangle-outline"></nb-icon>
            <div class="cv-house-leak-body">
              <strong>{{ 'cv_house.leak_warning_title' | translate }}</strong>
              <ul class="cv-house-leak-list">
                @for (w of e.leak_warnings; track $index) {
                  <li>{{ w }}</li>
                }
              </ul>
            </div>
          </div>
        }

        <label class="cv-house-guide-field">
          {{ 'cv_house.style_guide_label' | translate }}
          <textarea nbInput fullWidth rows="8"
                    [(ngModel)]="guideEdits[e.id]"
                    [ngModelOptions]="{ standalone: true }"></textarea>
        </label>

        <div class="cv-house-row-actions">
          <button nbButton status="basic" size="small" type="button"
                  (click)="saveGuide(e)" [disabled]="savingId === e.id">
            <nb-icon *ngIf="savingId === e.id" icon="loader-outline"></nb-icon>
            {{ 'cv_house.save_button' | translate }}
          </button>
          <button nbButton status="primary" size="small" type="button"
                  (click)="activate(e)" [disabled]="activatingId === e.id">
            <nb-icon *ngIf="activatingId === e.id" icon="loader-outline"></nb-icon>
            <nb-icon *ngIf="activatingId !== e.id" icon="checkmark-circle-2-outline"></nb-icon>
            {{ 'cv_house.activate_button' | translate }}
          </button>
        </div>
      } @else if (e.status === 'active' && e.style_guide) {
        <p class="cv-house-guide-readonly">{{ e.style_guide }}</p>
      }
    </article>
  }
</div>
